export const MAX_INDIAN_PHONE_DIGITS = 10;

export const sanitizePhoneValue = (value) => {
    if (typeof value !== 'string') return '';
    return value.replace(/\D/g, '');
};

export const getIndianPhoneError = (fullPhone, countryCode = '+91') => {
    const fullDigits = sanitizePhoneValue(fullPhone);
    const codeDigits = sanitizePhoneValue(countryCode);

    let localDigits = fullDigits;
    if (codeDigits && fullDigits.startsWith(codeDigits)) {
        localDigits = fullDigits.substring(codeDigits.length);
    }

    if (!localDigits) {
        return 'Please enter your mobile number.';
    }

    if (!/^\d+$/.test(localDigits)) {
        return 'Phone number should contain digits only.';
    }

    if (countryCode === '+91' || codeDigits === '91') {
        if (localDigits.length !== MAX_INDIAN_PHONE_DIGITS) {
            return 'Phone number must be exactly 10 digits.';
        }
    } else if (localDigits.length < 4) {
        return 'Please enter a valid phone number.';
    }

    return '';
};

export const formatPhoneWithCountryCode = (countryCode, phone) => {
    // phone is now already the full international phone number
    return phone;
};
